import { render, staticRenderFns } from "./ManageBooking.vue?vue&type=template&id=0bfe192c&scoped=true"
import script from "./ManageBooking.vue?vue&type=script&lang=js"
export * from "./ManageBooking.vue?vue&type=script&lang=js"
import style0 from "./ManageBooking.vue?vue&type=style&index=0&id=0bfe192c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfe192c",
  null
  
)

export default component.exports